/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-07-05T19:13:41.193
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	getRentRepairFeedbackDetailsEditInit,
	getRentRepairFeedbackDetailsView
} from '@api/rentmanage/RentRepairFeedbackDetails';

import {
listRentConsumeMaterialCompanyInit,
listRentConsumeMaterialCompanyByAuthorizations,
deleteRentConsumeMaterialCompany
} from '@api/rentmanage/RentConsumeMaterialCompany';

import {
listRentConsumeMaterialUserInit,
listRentConsumeMaterialUserByAuthorizations,
deleteRentConsumeMaterialUser
} from '@api/rentmanage/RentConsumeMaterialUser';

import {
listRentRepairFeedbackTypeInit,
listRentRepairFeedbackTypeByAuthorizations,
deleteRentRepairFeedbackType
} from '@api/rentmanage/RentRepairFeedbackType';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
		AdvanceQuery: cloneObj(RespCommonDef.AdvanceQuery)
	},
	actions: {
		getRentRepairFeedbackDetailsEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentRepairFeedbackDetailsEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getRentRepairFeedbackDetailsView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentRepairFeedbackDetailsView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
	}
};
